'use strict';

const scrollbarWidth = [
  function () {
    var width;

    return function () {
      if (typeof width === 'undefined') {
        width = getScrollbarWidth();
      }

      return width;
    };
  }
];

function getScrollbarWidth() {
  const wrapper = document.createElement('div');
  const content = document.createElement('div');
  let width;

  wrapper.style.position = 'absolute';
  wrapper.style.top = '-50px';
  wrapper.style.height = '50px';
  wrapper.style.overflow = 'scroll';

  wrapper.appendChild(content);
  document.body.appendChild(wrapper);

  width = wrapper.offsetWidth - content.offsetWidth;

  document.body.removeChild(wrapper);

  return width;
}

export default scrollbarWidth;



// WEBPACK FOOTER //
// ./app/src/services/scrollbar_width.js